<div [@fadeIn]="settings" *ngIf="settings.length" [ngClass]="benefitsClass">
  <div class="convenient-care">
    <div
      fxLayout
      fxLayout.lt-md="column"
      fxLayoutAlign="center center"
      fxLayoutAlign.lt-md="stretch"
      fxLayoutGap="16px"
    >
      <div
        [fxFlex.gt-md]="cardWidth"
        *ngFor="let card of settings; trackBy: trackByFnIndex; let i = index"
      >
        <app-benefit-card
          [promotion]="card"
          [attr.data-cy]="'convenient-care.benefit-card.' + i"
        >
        </app-benefit-card>
      </div>
    </div>
  </div>
</div>
